var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../elements/Basic");

var _GoalsSummary = require("./Components/GoalsSummary");

var _PenaltySummary = require("./Components/PenaltySummary");

var _HeaderComponents = require("./Components/HeaderComponents");

var _RelatedMatch = _interopRequireDefault(require("../../Match/RelatedMatch"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Liveticker/Header/index.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Header = function (_React$Component) {
  (0, _inherits2.default)(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header() {
    (0, _classCallCheck2.default)(this, Header);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Header, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          match = _this$props.match,
          matchGoals = _this$props.matchGoals,
          penaltyGoals = _this$props.penaltyGoals,
          onPressTeam = _this$props.onPressTeam,
          createTeamHref = _this$props.createTeamHref,
          NavWrapper = _this$props.NavWrapper;
      if (!match) return null;

      switch (match.period) {
        case 'PRE_MATCH':
          return _react.default.createElement(_Basic.View, {
            px: 2,
            py: 1,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 44,
              columnNumber: 21
            }
          }, _react.default.createElement(_HeaderComponents.Preticker, (0, _extends2.default)({}, _objectSpread(_objectSpread({}, match), {}, {
            onPressTeam: onPressTeam,
            createTeamHref: createTeamHref,
            NavWrapper: NavWrapper
          }), {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 45,
              columnNumber: 25
            }
          })));

        default:
          return _react.default.createElement(_Basic.View, {
            px: 2,
            py: 1,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 50,
              columnNumber: 21
            }
          }, _react.default.createElement(_HeaderComponents.Liveticker, (0, _extends2.default)({}, _objectSpread(_objectSpread({}, match), {}, {
            onPressTeam: onPressTeam,
            createTeamHref: createTeamHref,
            NavWrapper: NavWrapper
          }), {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 51,
              columnNumber: 25
            }
          })), penaltyGoals && penaltyGoals.length !== 0 && _react.default.createElement(_PenaltySummary.PenaltySummary, {
            penalties: penaltyGoals,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 53,
              columnNumber: 29
            }
          }), matchGoals && matchGoals.length !== 0 && _react.default.createElement(_GoalsSummary.GoalsSummary, {
            goals: matchGoals,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 56,
              columnNumber: 29
            }
          }), match.relatedMatch && _react.default.createElement(_RelatedMatch.default, (0, _extends2.default)({}, match.relatedMatch, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 58,
              columnNumber: 48
            }
          })));
      }
    }
  }]);
  return Header;
}(_react.default.Component);

Header.propTypes = {
  match: _propTypes.default.object.isRequired,
  matchGoals: _propTypes.default.arrayOf(Object).isRequired,
  penaltyGoals: _propTypes.default.arrayOf(Object),
  onPressTeam: _propTypes.default.func,
  createTeamHref: _propTypes.default.func,
  NavWrapper: _propTypes.default.func
};
var _default = Header;
exports.default = _default;